import {atom} from "recoil";
import {Alert} from "../model/Alert.ts";

export const alertsAtom = atom<Alert[]>({
    key: 'alertsAtom',
    default: []
})